export default {
  // cssVar: { key: 'app' },
  components: {
    //   Button: {
    //     colorPrimary: "red",
    //   },
    Table: {
      controlItemBgActive: '#e6f4ff',
    },
    Layout: {
      //   bodyBg: 'rgba(237, 242, 250, 1)',
      //   footerBg: 'rgba(237, 242, 250, 1)',
    },
    Breadcrumb: {
      itemColor: '#999999',
      linkColor: '#999999',
      lastItemColor: '#333333',
      linkHoverColor: '#333333',
    },
    Input: {
      //   hoverBorderColor: '#1890ff',
    },
  },
  token: {
    colorPrimary: '#2c2f57', // 品牌色
    colorPrimaryBg: '#e9eefe', //主色浅色背景色
    // colorPrimaryBg: '#e6f4ff', //主色浅色背景色
    colorLink: '#1890ff', // 链接色
    colorSuccess: '#11c036',
    colorWarning: '#fa8f00',
    colorError: '#f93232',
    colorTextBase: '#000', //

    colorPrimaryActive: '#1890ff',
    colorPrimaryHover: '#4096ff', //主色悬浮态
    colorPrimaryBorderHover: '#69b1ff', // 主色描边色悬浮态
    colorPrimaryBorder: '#91caff', //主色描边色
    colorPrimaryBgHover: '#bae0ff', //主色浅色背景悬浮态
    // colorPrimaryBorder: 'rgb(220, 239, 255)',
    // colorPrimaryBgHover: 'rgb(220, 239, 255)', // 主色浅色背景悬浮态
    colorInfo: '#2c2f57',
    wireframe: false,
  },
};
